<template>
  <div style="text-align: center">
    <img :src="topImg"
         alt=""
         style="width: 600px; margin: 24px;">
    <p style="width: 800px; text-align: left;margin: auto">Được thành lập năm 2017, VN Ngày Nay với công nghệ AI tiên tiến đã cán mốc hơn 35 triệu lượt cài đặt trên khắp cả nước. Nhờ tiềm năng và xu hướng công nghệ đón đầu thị trường, VN Ngày Nay đang không ngừng thu hút các dự án hợp tác chiến lược đến từ những tập đoàn quốc tế.
      Và để đào tạo thêm một thế hệ nhân tài mới, VN Ngày Nay quyết định triển khai chương trình Asia Interns cho các sinh viên tiềm năng đến làm việc, sinh sống và trưởng thành ở các thành phố hàng đầu Châu Á hiện nay như Thâm Quyến, Bangkok, Manila.
    </p>
    <img :src="introImg"
         alt=""
         style="width: 800px; margin: 24px auto 0;">
    <div style="display: flex;justify-content: center;">
      <div class="profession">
        <p class="title">PRODUCT<br>OPERATION</p>
        <p class="content">
          1. Tham gia thiết kế sản phẩm với lượng người dùng lên đến hàng chục triệu<br>
          2. Thu thập, phân tích các số liệu thị trường nhằm đưa ra chiến lược cho sản phẩm<br>
          3. Phân tích hành vi, tìm hiểu nhu cầu người dùng và lên ý tưởng tối ưu sản phẩm<br>
          4. Xử lý các vấn đề phát sinh trong quá trình vận hành sản phẩm<br>
          5. Tham gia hỗ trợ các hạng mục công nghệ số khác
        </p>
      </div>
      <div class="profession">
        <p class="title">TECH<br>FRESHER</p>
        <p class="content">
          1. Tham gia phát triển chức năng và tối ưu hóa hiệu suất của sản phẩm<br>
          2. Thiết kế, phát triển và bảo trì các sản phẩm mới<br>
          3. Tham gia thảo luận với các Giám đốc Sản phẩm về nhu cầu và các tính năng mới<br>
          4. Dành riêng cho các sinh viên đang theo học hoặc vừa tốt nghiệp các ngành IT/Lập trình.
        </p>
      </div>
    </div>
    <div style="width: 800px;border: 2px solid #000;margin: 0 auto 30px">
      <p class="title">BẠN SẼ ĐƯỢC</p>
      <div class="intro-box">
        <div class="intro-info">
          <img :src="intro01">
          Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi
        </div>
        <div class="intro-info">
          <img :src="intro02">
          Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi
        </div>
        <div class="intro-info">
          <img :src="intro03"
               style="height: 48px; margin-left: -33px;">
          Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi
        </div>
        <div class="intro-info">
          <img :src="intro04">
          Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi
        </div>
        <div class="intro-info">
          <img :src="intro05">
          Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi
        </div>
        <div class="intro-info">
          <img :src="intro06">
          Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi
        </div>
      </div>
    </div>
    <p class="title">ĐIỀU KIỆN THAM GIA</p>
    <div class="condition-box">
      <div class="condition-item">
        <img :src="condition01">
        <p>Là sinh viên năm cuối, kế cuối với thành tích học tập ấn tượng</p>
      </div>
      <div class="condition-item">
        <img :src="condition02">
        <p>Là sinh viên khá - giỏi vừa tốt nghiệp, kinh nghiệm làm việc dưới 1 năm</p>
      </div>
      <div class="condition-item">
        <img :src="condition03">
        <p>Tiếng Anh lưu loát, giao tiếp tự tin, tư duy logic tốt, ham học hỏi và có tinh thần cầu tiến</p>
      </div>
      <div class="condition-item">
        <img :src="condition04">
        <p>Yêu thích lĩnh vực công nghệ số - mobile app và mong muốn làm việc ở một thành phố công nghệ cao</p>
      </div>
    </div>
    <p class="title">ĐỐI TÁC TIÊU BIỂU</p>
    <img :src="company"
         width="800">
    <p style="width: 800px; font-size: 22px;color: red; text-align: left; margin: 24px auto 30px;">
      <b>
        Thông tin liên hệ:<br>
        - Địa chỉ: 196 Hoàng Diệu, Phường 8, Quận 4, TP.HCM<br>
        - Phòng Nhân sự: 028.3636.2034<br>
        - Email: tuyendung@vngaynay.vn
      </b>
    </p>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      topImg: require("../assets/image/top-title.png"),
      introImg: require("../assets/image/intro.png"),
      intro01: require("../assets/image/intro/intro01.png"),
      intro02: require("../assets/image/intro/intro02.png"),
      intro03: require("../assets/image/intro/intro03.png"),
      intro04: require("../assets/image/intro/intro04.png"),
      intro05: require("../assets/image/intro/intro05.png"),
      intro06: require("../assets/image/intro/intro06.png"),
      condition01: require("../assets/image/condition/condition01.png"),
      condition02: require("../assets/image/condition/condition02.png"),
      condition03: require("../assets/image/condition/condition03.png"),
      condition04: require("../assets/image/condition/condition04.png"),
      company: require("../assets/image/company.png"),
    };
  },
};
</script>

<style scoped>
.profession {
  width: 400px;
  padding: 0 12px;
}
.title {
  color: red;
  font-size: 22px;
  margin: 18px 0;
  font-weight: bold;
}
.content {
  text-align: left;
  margin-top: 12px;
  font-size: 20px;
  margin-bottom: 24px;
}
.intro-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0;
}
.intro-info {
  width: 240px;
  padding: 0;
  font-size: 12px;
  text-align: left;
  margin: 0 20px 12px;
}
.intro-info img {
  float: left;
  margin-right: 12px;
  height: 54px;
}
.condition-box {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  padding: 0;
  font-size: 12px;
}
.condition-item img {
  height: 80px;
}
.condition-item {
  width: 160px;
  margin: 0 12px;
  padding: 0;
}
div {
  padding: 0 75px;
}

h1,
h3 {
  font-weight: bolder;
  color: rgb(55, 102, 189);
}
p {
  color: #06295a;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// Want.vue?77b15fe2